export const GRAFANA_ORIGIN = 'https://grafana.neo4j.io';
export const INCIDENT_IO_API_PROXY_PATH = '/incident/api';
export const NEO4J_CLUSTERS_BASE_URL = '/neo4j-clusters';
export const NEO4J_DATABASES_BASE_URL = '/neo4j-databases';
export const NEO4J_SERVERS_BASE_URL = '/neo4j-servers';
export const AURA_OPERATIONS_BASE_URL = '/aura-operations';
export const PLATFORMX_DATABASES_EVENT_ID = 'aura.portal.databases';
export const PLATFORMX_DBMS_EVENT_ID = 'aura.portal.dbms';
export const SYSTEM_DATABASE_NAME = 'system';

// Incident.io API id for the `Aura Databases` multi-select custom field.
export const INCIDENT_IO_AURA_DATABASES_CUSTOM_FIELD_ID =
  '01KEVH6GSTNTT9VSGR6VPX89TH';

/**
 * Baseline option id for the sole positive `custom_field[…][one_of]` when no option exists
 * for this database yet.
 *
 * 01KHVF13R49RJXS9M1P1ZBGP49 = `replace-me`
 */
export const INCIDENT_IO_AURA_DATABASES_BASELINE_ONE_OF_OPTION_ID =
  '01KHVF13R49RJXS9M1P1ZBGP49';
